import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { activateSetting, deactivateSetting } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetActivate(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: {
            id: string | undefined
            poolShip: number | undefined
        }) => {
            return activateSetting(payload)
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_activated', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch()
            toast.success('با موفقیت انجام شد')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'activate',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
